import { render } from "./DocumentCreation.vue?vue&type=template&id=494c580b&scoped=true"
import script from "./DocumentCreation.vue?vue&type=script&lang=js"
export * from "./DocumentCreation.vue?vue&type=script&lang=js"

import "./DocumentCreation.vue?vue&type=style&index=0&id=494c580b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-494c580b"]])

export default __exports__